<template>
  <header class="mast">
    <a :href="logoHref" aria-label="Decast home">
      <img class="wm" :src="logo" alt="Decast" @error="hideLogo" />
    </a>

    <router-link v-if="backTo" class="back" :to="backTo">
      <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M15 18l-6-6 6-6" /></svg>{{ backLabel }}
    </router-link>

    <div v-else-if="crumb" class="mast-kicker"><span class="cur">{{ crumb }}</span></div>

    <span class="grow"></span>

    <a v-if="ghost" class="mast-ghost" href="https://app.decast.live" target="_blank" rel="noopener">Run yours on Decast →</a>

    <ContentCredentials v-if="provenance" :provenance="provenance" compact tone="lime" align="right" />
    <span v-else-if="verified" class="mast-verified" title="Content Credentials: cryptographically signed & tamper-evident">
      <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 3l7 2.6v5.1c0 4.3-3 8.2-7 9.3-4-1.1-7-5-7-9.3V5.6L12 3z" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round" /><path d="M8.8 11.7l2.2 2.2 4.2-4.6" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" /></svg>
      Verified
    </span>

    <ShareMenu v-if="showShare" :title="shareTitle" />
  </header>
</template>

<script>
import ShareMenu from './ShareMenu.vue';
import ContentCredentials from '@/components/credentials/ContentCredentials.vue';

export default {
  name: 'EvtHeader',
  components: { ShareMenu, ContentCredentials },
  props: {
    crumb: { type: String, default: '' },
    shareTitle: { type: String, default: 'Decast' },
    backTo: { type: [String, Object], default: null },
    backLabel: { type: String, default: 'The brief' },
    ghost: { type: Boolean, default: false },
    verified: { type: Boolean, default: false },
    // normalized credential; when given, the badge opens the inspector on hover
    provenance: { type: Object, default: null },
    showShare: { type: Boolean, default: true },
    logoHref: { type: String, default: 'https://app.decast.live' },
  },
  data() {
    return { logo: 'https://app.decast.live/img/logot.39d4903f.svg' };
  },
  methods: {
    hideLogo(e) {
      e.target.style.display = 'none';
    },
  },
};
</script>
